export interface IDemandWLGenerator {
    _id: string;
    templateName: string;
    createBy: string;
    demandId: string;
    siteId: string;
    searchPublisherOnDomain: boolean;
    searchPublisherOnSourceDomain: boolean;
    includePublishers: boolean;
    publishers: { key:string,value:string }[];
    pubAccId: { key:string,value:string }[];
    dimensions: { key:string,value:string }[];
    siteDomain: {
        domain: string;
        relationship: ('DIRECT' | 'RESELLER') [];
        includeInventoryPartnerDomain: boolean;
    }
    demandPartnerDomain: {
        domain: string;
        relationship: ('DIRECT' | 'RESELLER') [];
    }
    includeSiteDomainAdsTxtLine: boolean;
    excludeGlobalBundleList: boolean;
    scheduleReport:{
        isActive:boolean;
        runningDays: string[];
        emails?: string[];
    }
    integrations: string[];
    integrationTargetListIds: { [key: string]: string[] };
    updateViaIntegration: boolean;
    manuallyAddedBundles: { bundleId: string }[];
    manuallyRemovedBundles: { bundleId: string }[];
    lastRunAt?: string | Date | null;
}

export enum DemandTypes {
    WITHOUT_DEMAND_PARTNER_DOMAIN = "without demand partner domain",
}


export const initialDemandWLGeneratorObj: IDemandWLGenerator = {
    _id: null,
    createBy: '',
    includePublishers: true,
    templateName: '',
    demandId: '',
    siteId: '',
    publishers: [],
    searchPublisherOnDomain: true,
    searchPublisherOnSourceDomain: true,
    pubAccId: [],
    dimensions: [],
    siteDomain: {
        domain: '',
        relationship: ['DIRECT','RESELLER'],
        includeInventoryPartnerDomain: false,
    },
    demandPartnerDomain: {
        domain: '',
        relationship: ['DIRECT','RESELLER'],
    },
    includeSiteDomainAdsTxtLine: false,
    excludeGlobalBundleList: false,
    scheduleReport:{
        isActive:false,
        runningDays: [],
        emails: [],
    },
    integrations: [],
    integrationTargetListIds: {},
    updateViaIntegration: false,
    manuallyAddedBundles: [],
    manuallyRemovedBundles: [],
};

export const tableAppAdsTxt_V1Filled = [
    { key: 'AppIdentifier', value: 'AppIdentifier' },
    { key: 'AppStoreIdentifier', value: 'AppStoreIdentifier' },
    { key: 'DomainName', value: 'DomainName' },
    { key: 'AdvertisingSystem', value: 'AdvertisingSystem' },
    { key: 'PubAccId', value: 'PubAccId' },
    { key: 'Relationship', value: 'Relationship' },
    { key: 'CAId', value: 'CAId' },
    { key: 'Subdomain', value: 'Subdomain' },
    { key: 'InventoryPartner', value: 'InventoryPartner' },
    { key: 'ErrorCode', value: 'ErrorCode' },
    { key: 'ErrorMessage', value: 'ErrorMessage' },
    { key: 'SourceDomain', value: 'SourceDomain' },
    { key: 'SourceRootDomain', value: 'SourceRootDomain' },
    { key: 'OwnerDomain', value: 'OwnerDomain' },
    { key: 'ManagerDomain', value: 'ManagerDomain' },
    { key: 'ManagerCountry', value: 'ManagerCountry' },
];

export interface IValidationErrors {
    dimensions:string,
    templateName:string,
}


